// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"linkButton_linkButton__jlk9q","linkButtonCenter":"linkButton_linkButtonCenter__m5TsX"};